import { render, staticRenderFns } from "./SAmountInput.vue?vue&type=template&id=22d2963e&scoped=true&"
import script from "./SAmountInput.vue?vue&type=script&lang=ts&"
export * from "./SAmountInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d2963e",
  null
  
)

export default component.exports